/**
 * @generated SignedSource<<f816225c59f1fde69d9ed3fe14c13045>>
 * @relayHash 3d4e870877dd2a0bda363283a8a6a8ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 40c541d31e88e1e53728ce697e7615b9cb264308bd85d7540f3d457daa32b191

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiExperimentCoordinatorEndOfTrialExtensionQuery } from './uiExperimentCoordinatorEndOfTrialExtensionQuery.graphql';

const node: PreloadableConcreteRequest<uiExperimentCoordinatorEndOfTrialExtensionQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "40c541d31e88e1e53728ce697e7615b9cb264308bd85d7540f3d457daa32b191",
    "metadata": {},
    "name": "uiExperimentCoordinatorEndOfTrialExtensionQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
